<template>
  <div class="team">
    <Header 
      title="Criar um post"
    ></Header>
    <div class="container">
      
      <form @submit.stop.prevent="handleSubmit">
        <b-form-group description="" label="Titulo do post">
          <b-form-input v-model="forum_post.title"
            type="text"
            maxlength="50"
            placeholder="" required>
          </b-form-input>
        </b-form-group>

        <b-form-group description="" label="Conteúdo">
          <ckeditor required :editor="editor" v-model="forum_post.content" :config="editorConfig"></ckeditor>
        </b-form-group>

        <b-button type="submit" variant="primary">Criar</b-button>
      </form>
          
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'ForumCreate',
  metaInfo: {
    title: 'Criar um post'
  },
  data () {
    return {
      forum_post: { title: '', content: '', category: '' },
      editor: ClassicEditor,
      editorData: '<p>escreva aqui seu post</p>',
      editorConfig: {
          toolbar: {
              items: [
                  'bold',
                  'italic',
                  'link',
                  'undo',
                  'redo'
              ]
          }
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$http.post(`forum_posts.json`, { forum_post: this.forum_post })
          .then(response => {
            this.$notify({
              group: 'all',
              title: 'Post criado!',
            });
            this.$router.push({ name: 'ForumSingle', params: { id: response.data.id }})
          })
          .catch(response => {
            // alert(JSON.stringify(response.data))
          })
    },
  },
  mounted () {
  },
  components: {
    Header
  }
}
</script>

<style lang="sass" scoped>

</style>
